<template lang="pug">
  b-row.mb-5
    b-col
      router-view(@categories-changed='reloadOrganizationsPanel')
</template>

<script>
export default {
  name: 'manager-organizations-categories',
  methods: {
    reloadOrganizationsPanel() {
      this.$parent.$refs.organizationsPanel.panelReload()
    },
  },
}
</script>
